@keyframes menu-overflow-bounce {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(3px); }
}

.menu-overflow-indicator {
  animation: menu-overflow-bounce 1.2s ease-in-out infinite;
}
